import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';
import { RUC, OTROS } from '../../../common/types/tipoDocumentoType';

import creditoClienteService from '../../../service/creditoCobranza/creditoClienteService';
import monedaService from '../../../service/administracion/monedaService';
import clienteService from '../../../service/administracion/clienteService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            monedas: [],
            clientes: [],
            estados: estadoMock.values,
            filter: {
                nombre: "",
                idCredito: 0,
                estado: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idCliente: 0,
            idMoneda: 0,
            valor: 0,
            monedas: [],
            clientes: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            idCliente: 0,
            estado: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await creditoClienteService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Línea de crédito de clientes.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await creditoClienteService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Línea de crédito de clientes.pdf");

    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await creditoClienteService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        if (!values.flagUse) {
            dialog.warning(`No se puede editar el cliente ya tiene en uso este crédito.`);
            return;
        }
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await creditoClienteService.eliminar(values);
            else
                response = await creditoClienteService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(
                    <ul>
                        {response.data.messages.map((item) => (
                            <li>{item}</li>
                        ))}
                    </ul>
                );
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        //formValues.clientes = this.state.clientes;
        formValues.clientes = this.state.clientes ? this.state.clientes.filter(m => [RUC.ID, OTROS.ID].includes(m.idTipoDocumento)) : [];

        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        if (!values.flagUse) {
            dialog.warning(`No se puede editar el cliente ya tiene en uso este crédito.`);
            return;
        }
        this.setState({
            visible: true,
            formValues: {
                id: values.id,
                valor: values.linea,
                idCliente: values.idCliente,
                idMoneda: values.idMoneda,
                monedas: this.state.monedas,
                clientes: this.state.clientes,
            }
        });
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await creditoClienteService.registrar(values);
            else
                response = await creditoClienteService.modificar(values);

            if (response.status === 200) {


                form.resetFields();
                this.setState({ visible: false });

                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    async componentDidMount() {
        this._initPagination(this.state.filter, creditoClienteService.paginacion);
        const monedas = await monedaService.listar();
        const clientes = await clienteService.listar();
        const clientes_exo = clientes ? clientes.filter(m => [RUC.ID, OTROS.ID].includes(m.idTipoDocumento)) : [];

        this.setState({
            loadingSource: false,
            monedas: monedas ? monedas : [],
            clientes: clientes ? clientes : [],

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Línea de crédito de clientes"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    //onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}